import React, { useState, forwardRef } from "react";
import { Dropdown } from "./dropdown";
import { IDropdownProps } from "./dropdown";
import { DropDownChoice } from "../../../types/components/dropdown";

// Labels used to show to users and values is used to be send as an API parameter.
const accountTypeDropdownChoices: DropDownChoice[] = [
  { label: "Checking", value: "Checking", dbValue: "CHECKING" },
  { label: "Corporate", value: "Corporate", dbValue: "CORPORATE" },
  { label: "Savings", value: "Savings", dbValue: "SAVINGS" },
  { label: "Corporate Savings", value: "Corporate Savings", dbValue: "CORP_SAVINGS" },
];

/**
 * This function is used for mapping choice value to what we store in DB (what we pass to our API
 * when adding a new bank account).
 * @param accountTypeValue accountTypeDropdownChoices.value string
 * @return string accountTypeDropdownChoices.dbValue if any.
 */
export const accountTypeToDBFieldValueMapping = (accountTypeValue: string) => {
  let dbValue = null;
  for (let accountType of accountTypeDropdownChoices) {
    if (accountType.value === accountTypeValue) {
      dbValue = accountType.dbValue;
      break;
    }
  }
  return dbValue;
};

export const BankAccountTypeDropdown = forwardRef((props: IDropdownProps, ref: any) => {
  const { label, setValue, formName, errors, inputAccessoryViewID, onFocus, onSubmitEditing } =
    props;

  const [selectedType, setSelectedType] = useState<any>(null);

  const onSelectHandler = (value: string) => {
    setValue(value);
    setSelectedType(value);
  };

  return (
    <Dropdown
      onSelectHandler={onSelectHandler}
      value={selectedType}
      label={label}
      errors={errors}
      leftAlignText
      formName={formName}
      inputAccessoryViewID={inputAccessoryViewID}
      onFocus={onFocus}
      ref={ref}
      onSubmitEditing={onSubmitEditing}
      items={accountTypeDropdownChoices}
    />
  );
});
